import { useTranslation } from '@mint-lib/i18n';
import { Card, Chip, typographyVariants } from '@mint-lib/tw-components';

import { CHANNELS_AND_CATEGORIES } from '../../../constants/ComponentsConstants';
import { snakeCaseToCamelCase } from '../../../utils/snakeCaseToCamelCase.js';

type Props = {
  category: string;
};

const IntegrationTypeCard = ({ category }: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');

  const categoryProps = CHANNELS_AND_CATEGORIES[snakeCaseToCamelCase(category)];

  return (
    <Card className="w-full p-2">
      <div className="mb-4">
        <h4 className={typographyVariants({ variant: 'h4' })}>
          {t('Platform type')}
        </h4>
      </div>

      <div>
        <Chip color={'silver'} variant="outline">
          {categoryProps?.chipProps?.iconComponent}
          {categoryProps?.label}
        </Chip>
      </div>
    </Card>
  );
};

export default IntegrationTypeCard;
